export interface AssetMgtPageLoader {
    /**
     * [[AssetMgtPageLoaderMgt]]載入頁面時執行，於此方法寫入與 DOM 無關的業務邏輯
     */
    load(): Promise<void>
    /**
     * 於 [[load]]執行完成後，且Html Document ready 後執行，於此方法寫入與 DOM 相關的業務邏輯
     */
    loadOnDocumentReady(): Promise<void>
}

export abstract class AssetMgtPageLoaderBase implements AssetMgtPageLoader {
    load(): Promise<void> {
        throw new Error("Method not implemented.")
    }
    loadOnDocumentReady(): Promise<void> {
        throw new Error("Method not implemented.")
    }
}